export default "__VITE_ASSET__EifyCyWy__"